import { render } from "./DeliveryAddressSelector.vue?vue&type=template&id=1ebbe3c0&scoped=true"
import script from "./DeliveryAddressSelector.vue?vue&type=script&lang=js"
export * from "./DeliveryAddressSelector.vue?vue&type=script&lang=js"

import "./DeliveryAddressSelector.vue?vue&type=style&index=0&id=1ebbe3c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ebbe3c0"]])

export default __exports__